import React from 'react';

/**
 * Helper function to create a label with a red asterisk for required fields
 * @param {string} text - The label text (e.g., "Email *")
 * @returns {JSX.Element|string} - Label with styled asterisk or plain text
 */
export const formatRequiredLabel = (text) => {
  if (!text || typeof text !== 'string') return text;
  
  // Check if label ends with " *"
  if (text.trim().endsWith('*')) {
    const labelText = text.trim().slice(0, -1).trim();
    return (
      <>
        {labelText} <span style={{ color: '#f44336' }}>*</span>
      </>
    );
  }
  
  return text;
};
